import React, { useEffect, useState } from 'react';
import { Menu, Phone, X } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [lang, setLang] = useState('EN');
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleLang = () => {
    setLang(lang === 'EN' ? 'ES' : 'EN');
  };
  const navLinks = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  // Lock body scroll while the mobile menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);
  return <>
      <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/80 border-b border-gray-100 shadow-sm h-[60px] md:h-20 flex items-center" data-id="element-42">
        <div className="container mx-auto px-4 flex items-center justify-between h-full" data-id="element-43">
          {/* Logo */}
          <a href="#" className="flex items-center h-full py-2" data-id="element-44">
            <img src="https://cdn.magicpatterns.com/uploads/2wj6pTpsWY9CCgyrdYDcDA/logo-white.png" alt="Comfy Clean Co." className="h-full object-contain max-h-[40px] md:max-h-[50px]" data-id="element-45" />
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-46">
            <nav className="flex items-center space-x-6" data-id="element-47">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-700 hover:text-brand-navy transition-colors" data-id="element-48">
                  {link.name}
                </a>)}
            </nav>

            <div className="flex items-center space-x-4 border-l pl-6 border-gray-200" data-id="element-49">
              <button onClick={toggleLang} className="text-sm font-bold text-gray-500 hover:text-brand-green transition-colors w-8" data-id="element-50">
                {lang}
              </button>

              <a href="tel:9159795151" className="flex items-center text-brand-navy font-semibold hover:text-brand-green transition-colors" data-id="element-51">
                <Phone className="w-4 h-4 mr-2" data-id="element-52" />
                (915) 979-5151
              </a>

              <Button className="brand-gradient text-white border-0 hover:opacity-90 rounded-full px-6 font-semibold" data-id="element-53">
                Book Now
              </Button>
            </div>
          </div>

          {/* Mobile Nav Triggers */}
          <div className="flex items-center md:hidden space-x-4" data-id="element-54">
            <a href="tel:9159795151" className="text-brand-navy p-2" aria-label="Call us" data-id="element-55">
              <Phone className="w-5 h-5" data-id="element-56" />
            </a>

            <button type="button" onClick={() => setMenuOpen(true)} aria-label="Open menu" aria-expanded={menuOpen} className="p-2 text-gray-700 hover:text-brand-navy transition-colors" data-id="element-57">
              <Menu className="w-6 h-6" data-id="element-58" />
            </button>
          </div>
        </div>
      </header>

      {/* Full-screen mobile menu.
            Rendered OUTSIDE the <header> on purpose: the header uses backdrop-blur
            (a backdrop-filter), which would otherwise become the containing block
            for any position:fixed child and trap this overlay inside the 60px bar. */}
      {menuOpen && <div role="dialog" aria-modal="true" aria-label="Mobile navigation" className="md:hidden fixed inset-0 z-[100] w-screen h-screen flex flex-col" style={{
      backgroundColor: '#ffffff'
    }} data-id="element-59">
          {/* Top bar with close */}
          <div className="flex items-center justify-between px-6 h-[60px] border-b border-gray-100 flex-shrink-0" data-id="element-60">
            <span className="font-heading font-bold text-lg text-brand-navy" data-id="element-61">
              Menu
            </span>
            <button type="button" onClick={() => setMenuOpen(false)} aria-label="Close menu" className="p-2 -mr-2 text-gray-600 hover:text-brand-navy transition-colors" data-id="element-62">
              <X className="w-7 h-7" data-id="element-63" />
            </button>
          </div>

          {/* Centered menu content filling the screen */}
          <div className="flex-1 overflow-y-auto flex flex-col items-center justify-center px-6 py-10" data-id="element-64">
            <nav className="flex flex-col items-center space-y-8" data-id="element-65">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMenuOpen(false)} className="text-2xl font-semibold text-gray-900 hover:text-brand-green transition-colors" data-id="element-66">
                  {link.name}
                </a>)}
            </nav>

            <div className="w-full max-w-xs mt-12 pt-10 border-t border-gray-100 flex flex-col items-center space-y-6" data-id="element-67">
              <button onClick={toggleLang} className="text-lg font-bold text-gray-600 hover:text-brand-green transition-colors" data-id="element-68">
                Language: {lang}
              </button>

              <a href="tel:9159795151" className="flex items-center justify-center text-xl text-brand-navy font-semibold" data-id="element-69">
                <Phone className="w-6 h-6 mr-3" data-id="element-70" />
                (915) 979-5151
              </a>

              <Button className="brand-gradient text-white w-full rounded-full h-12 text-lg font-semibold mt-2" data-id="element-71">
                Book Now
              </Button>
            </div>
          </div>
        </div>}
    </>;
}